import { ContentCopy, Fax, MailOutline, Phone } from "@mui/icons-material";
import {
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { Fragment } from "react";

export default function ContactDetails(props) {
  const { enqueueSnackbar } = useSnackbar();

  const copyToClipboard = async (toCopy) => {
    try {
      await navigator.clipboard.writeText(toCopy);
      enqueueSnackbar("Text erfolgreich in die Zwischenablage kopiert.", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Fehler beim Kopieren in die Zwischenablage.", {
        variant: "error",
      });
    }
  };

  const KontaktItem = (item, index) => {
    let icon = <Fragment></Fragment>;
    let text = <Fragment></Fragment>;
    switch (item.typ) {
      case "Mobiltelefon":
      case "Telefon":
        icon = <Phone sx={{ width: "22px", height: "22px" }} />;
        text = <a href={"tel:" + item.nummer}>{item.nummer}</a>;
        break;
      case "Telefax":
        icon = <Fax sx={{ width: "22px", height: "22px" }} />;
        text = item.nummer;
        break;
      case "E-Mail":
        icon = <MailOutline sx={{ width: "22px", height: "22px" }} />;
        text = (
          <a href={"mailto:" + item.nummer + "?subject=Betreff"}>
            {item.nummer}
          </a>
        );
        break;
      default:
    }
    return (
      <ListItem key={index} size="small" sx={{ pt: "0px", pb: "0px" }}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText
          primary={<Typography variant="body">{text}</Typography>}
        />
        <ListItemIcon sx={{ minWidth: "0px" }}>
          <Tooltip title="in Zwischenablage kopieren">
            <IconButton onClick={(e) => copyToClipboard(item.nummer)}>
              <ContentCopy sx={{ width: "16px", height: "16px" }} />
            </IconButton>
          </Tooltip>
        </ListItemIcon>
      </ListItem>
    );
  };

  if (props.kontakt.items) {
    return (
      <Fragment>

          <Typography component="div" variant="h3">
            {props.label}
          </Typography>
          {props.label_name && (
            <Typography component="div" variant="title">
              {props.label_name}
            </Typography>
          )}
          {props.label_funktion && (
            <Typography component="div" variant="body">
              {props.label_funktion}
            </Typography>
          )}
          <List
            dense
            sx={{
              mt: "20px",
              mb: "0px",
              borderTop: "1px solid",
              borderColor: "#CACACA",
            }}
          >
            {props.kontakt.items.map((item, index) => KontaktItem(item, index))}
          </List>
      </Fragment>
    );
  } else return <Fragment></Fragment>;
}
